import { NeoModel } from "@singularsystems/neo-core";
import { injectable } from "inversify";
import { IReportType } from "@singularsystems/neo-reporting/dist/Models/IReportType";
import TaxSummaryExtractReport from "./TaxSummaryExtractReport/TaxSummaryExtractReport";
import CashTransactionsExtractReport from "./CashTransactionsExtractReport/CashTransactionsExtractReport";
import SecurityTransactionsExtractReport from "./SecurityTransactionsExtractReport/SecurityTransactionsExtractReport";
import SecurityHoldingsExtractReport from "./SecurityHoldingsExtractReport/SecurityHoldingsExtractReport";
import CashHoldingsExtractReport from "./CashHoldingsExtractReport/CashHoldingsExtractReport";
import SAMExtractReport from "./SAMExtractReport/SAMExtractReport";
import DividendWithholdingTaxReport from "./DividendWithholdingTaxReport/DividendWithholdingTaxReport";

@injectable()
@NeoModel
export default class ClientReportingService {
    public getReports() {
        return [
            CashHoldingsExtractReport,
            CashTransactionsExtractReport,
            SecurityHoldingsExtractReport,
            SecurityTransactionsExtractReport,
            TaxSummaryExtractReport,
            SAMExtractReport,
            DividendWithholdingTaxReport
        ] as unknown as IReportType[]
    }
}